export default "__VITE_ASSET__DN_FA1Ks__"